<template>
  <v-text-field
    :append-icon="(!cardType || cardType==='unknown') ? icon : ''"
    box
    :disabled="disabled"
    hide-details
    label="Card Number"
    :mask="cardMask"
    :required="required"
    :rules="rules"
    v-model="cardNumber"
  >
    <img slot="append" :src="'/static/cards/' + cardType + '.svg'" height="24px" v-if="cardType && cardType!=='unknown'" />
  </v-text-field>
</template>

<script>
import ValidationMixin from '@/mixins/validation'

export default {
  mixins: [
    ValidationMixin
  ],

  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: 'fa-credit-card'
    },
    required: {
      type: Boolean,
      default: true
    },
    rules: {
      type: Array,
      default () {
        return [
          (v) => !!v || 'Card number is required',
          (v) => this.validateCardNumber(v) || 'Card number is invalid'
        ]
      }
    },
    showNone: {
      type: Boolean,
      default: true
    },
    value: String
  },

  computed: {
    cardNumber: {
      get () {
        return this.value
      },
      set (cardNumber) {
        this.$emit('input', cardNumber)
      }
    },

    cardMask () {
      if (this.cardType === 'amex') {
        return '#### ###### #####'
      } else if (this.cardType === 'diners') {
        return '#### ###### #####'
      } else if (this.cardType === 'discover') {
        return '#### #### #### ####'
      } else if (this.cardType === 'jcb') {
        return '#### #### #### ####'
      } else if (this.cardType === 'jcb15') {
        return '#### ###### #####'
      } else if (this.cardType === 'maestro') {
        return '#### #### #### ####'
      } else if (this.cardType === 'mastercard') {
        return '#### #### #### ####'
      } else if (this.cardType === 'unionpay') {
        return '#### #### #### ####'
      } else if (this.cardType === 'visa') {
        return '#### #### #### ####'
      }
      return '#### #### #### ####'
    },

    cvvMask () {
      if (this.cardType === 'amex' || this.cardType === 'diners' || this.cardType === 'jcb15') {
        return '####'
      }
      return '###'
    },

    cardType () {
      let amex = /^3[47]\d{0,13}/
      let diners = /^3(?:0([0-5]|9)|[689]\d?)\d{0,11}/
      let discover = /^(?:6011|65\d{0,2}|64[4-9]\d?)\d{0,12}/
      let jcb = /^(?:35\d{0,2})\d{0,12}/
      let jcb15 = /^(?:2131|1800)\d{0,11}/
      let maestro = /^(?:5[0678]\d{0,2}|6304|67\d{0,2})\d{0,12}/
      let mastercard = /^(5[1-5]\d{0,2}|22[2-9]\d{0,1}|2[3-7]\d{0,2})\d{0,12}/
      let unionpay = /^62\d{0,14}/
      let visa = /^4\d{0,15}/

      if (amex.test(this.cardNumber)) {
        return 'amex'
      } else if (diners.test(this.cardNumber)) {
        return 'diners'
      } else if (discover.test(this.cardNumber)) {
        return 'discover'
      } else if (jcb.test(this.cardNumber)) {
        return 'jcb'
      } else if (jcb15.test(this.cardNumber)) {
        return 'jcb15'
      } else if (maestro.test(this.cardNumber)) {
        return 'maestro'
      } else if (mastercard.test(this.cardNumber)) {
        return 'mastercard'
      } else if (unionpay.test(this.cardNumber)) {
        return 'unionpay'
      } else if (visa.test(this.cardNumber)) {
        return 'visa'
      }
      return 'unknown'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/forms/CardNumber.vue